// extracted by mini-css-extract-plugin
export var container = "_cd-0";
export var infoIcon = "_cd-2";
export var titleRowCol = "_cd-1";